(() => {
  const hostSelector = 'trigger-host';
  const styleId = 'theme-accessibility-widget-position';
  const iconUrl = document.currentScript?.dataset.iconUrl;
  const positionStyle = `
    .trigger-wrapper.trigger-type-icon-only-tab {
      top: auto !important;
      right: 0 !important;
      bottom: 208px !important;
    }

    .trigger-wrapper.trigger-type-icon-only-tab .trigger-container {
      transform: translateY(-100%) !important;
    }

    .trigger-wrapper.trigger-type-icon-only-tab .triggerIcon {
      top: 50% !important;
      left: 50% !important;
      translate: -50% -50% !important;
      width: 24px !important;
      height: 24px !important;
      margin: 0 !important;
      font-size: 0 !important;
      background: url("${iconUrl}") center / contain no-repeat !important;
    }

    .trigger-wrapper.trigger-type-icon-only-tab .triggerIcon::before {
      content: none !important;
      display: none !important;
    }

    @media only screen and (min-width: 1025px) {
      .trigger-wrapper.trigger-type-icon-only-tab .trigger-container,
      .trigger-wrapper.trigger-type-icon-only-tab .trigger {
        width: 40px !important;
        height: 40px !important;
      }

      .trigger-wrapper.trigger-type-icon-only-tab .trigger {
        border-radius: 8px 0 0 8px !important;
      }
    }

    @media only screen and (max-width: 1024px) {
      .trigger-wrapper.trigger-type-icon-only-tab {
        bottom: 150px !important;
        right: 20px !important;
      }

      .trigger-wrapper.trigger-type-icon-only-tab .trigger-container,
      .trigger-wrapper.trigger-type-icon-only-tab .trigger {
        width: 44px !important;
        height: 44px !important;
      }

      .trigger-wrapper.trigger-type-icon-only-tab .trigger {
        border-radius: 50% !important;
      }

    }
  `;

  const addPositionStyle = (root) => {
    if (root.querySelector(`#${styleId}`)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = positionStyle;
    root.append(style);
  };

  const applyPosition = (host) => {
    if (host.shadowRoot) addPositionStyle(host.shadowRoot);
    addPositionStyle(host);
  };

  const scan = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches(hostSelector)) applyPosition(node);
    node.querySelectorAll(hostSelector).forEach(applyPosition);
  };

  scan(document.documentElement);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => addedNodes.forEach(scan));
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (window.customElements) {
    customElements.whenDefined(hostSelector).then(() => scan(document.documentElement));
  }
})();
